// extracted by mini-css-extract-plugin
export default {"headerBar":"kJ-z","pointsSection":"lJ-z","goToDashboard":"mJ-z"};